import { ALI_PUB, ALLI_PUB, GOT_BY } from '../../creatives/config';

export const PRODUCT_ID_CUTTERS = [ALI_PUB, GOT_BY, ALLI_PUB];

export const offerParams = {
    viewRules: 'role_user',
    fields: 'name,iframe_supported,type_id,creative_placement',
    typeId: '1,2,6,7',
    limit: 300,
    lang: null,
};

export const placementParams = {
    fields: 'id,url,offer_id',
    statuses: 'allow',
    limit: 50,
};

export const deeplinkParams = {
    fields: 'id,link,description,code,offer_id',
    statuses: 'new,working',
};

export const creativeParams = {
    types: 'deeplink',
    fields: 'extInfoType,code,offerId,hash',
    isDeleted: false,
    limit: 5,
};

export const createCreativeParams = {
    type: 'deeplink',
};

export const CREATIVE_MAX_LENGTH = 100;

export const REF_TYPES = {
    99: 'epnbz',
    95: 'epn-profit',
    94: 'epn-registration',
    93: 'webreferral',
    92: 'epnbloggers2',
    91: 'epnbloggers',
    2297: 'epn-standard2',
};

export const ALI_PUB_DATA = { value: ALI_PUB, label: ALI_PUB };
export const GOT_BY_DATA = { value: GOT_BY, label: GOT_BY };

export const aliexpressRegexp = /https?:\/\/(?:[^/]+.)?aliexpress.(com|ru|us)/iu;
export const skuIdRegexp = /sku_id=\d+/;
export const aliexpressGoodsRegexp = /\/item\/(-\/)?(?:\d+?[\\-_])?(\d+?)(?:\/-detail)?\.html/u;
export const subIdRegexp = /^[a-zA-Z0-9_-]{0,50}$/;

export const INPUT_NAMES_BY_CREATIVE_ERROR = {
    422003: 'offer',
    422005: 'placement',
    422006: 'link',
    422009: 'placement',
    422010: 'link',
    422014: 'offer',
    422028: 'placement',
    422029: 'placement',
    422030: 'placement',
    422031: 'name',
    422046: 'link',
    422054: 'link',
};
